import { createSelector } from 'reselect';
import { flow, property } from 'lodash';

const geocodingSlice = property('contacts.geocoding');

export const isMapLoadingSelector = flow(geocodingSlice, (geocoding) => geocoding.get('loading'));
export const isMapErrorSelector = flow(geocodingSlice, (geocoding) => geocoding.get('error'));
export const coordinatesByIdSelector = createSelector(geocodingSlice, (geocoding) =>
  geocoding.getIn(['data']),
);
